interface Props {
  label?: string;
}

export function LoadingPlaceholder({ label = 'Loading…' }: Props) {
  return <p>{label}</p>;
}
